import React, {useContext} from 'react';

import {AccountSelectorContext} from '../../components/Search/SearchNav/AccountSelectorContextProvider';
import {useMeticulousRecorder} from './useMeticulousRecorder';

export const MeticulousWrapper = ({children}: {children: React.ReactNode}) => {
  const account = useContext(AccountSelectorContext);

  useMeticulousRecorder(account.selectedAccount?.name);
  return <>{children}</>;
};
